<template>
  <v-app-bar
    color="white lighten-4"
    style="z-index: 100;"
    :height="drawer == false ? 40 : 400"
    fixed
  >
    <v-toolbar-title class>
      <a
        href="/"
        class="font-weight-medium purple--text text--darken-4"
        style="text-decoration: none; font-size: 16px;"
      >NowNow</a>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <template>
      <v-app-bar-nav-icon v-if="!drawer" @click="drawer = true" class="toggle-menu"></v-app-bar-nav-icon>
      <v-navigation-drawer v-model="drawer" absolute temporary>
        <v-list nav dense>
          <v-list-item-group active-class="purple--text text--accent-4" clipped-right>
            <v-list-item @click="openSignUp();eventAnalytics('SgnMenuH')">
              <v-list-item-icon>
                <v-icon>mdi-account-edit</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-html="$t('Home.MenuHome.signUp')"></v-list-item-title>
            </v-list-item>

            <v-list-item @click="openLogin">
              <v-list-item-icon>
                <v-icon>mdi-login</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t('Home.MenuHome.login') }}</v-list-item-title>
            </v-list-item>

            <v-list-item @click="openHome();eventAnalytics('Home')">
              <v-list-item-icon>
                <v-icon>mdi-home</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t('Home.MenuHome.home') }}</v-list-item-title>
            </v-list-item>
            

            <v-list-item @click="openProduct();eventAnalytics('ProdMenuH')">
              <v-list-item-icon>
                <v-icon>mdi-file-check</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t('Home.MenuHome.product') }}</v-list-item-title>
            </v-list-item>

            <v-list-item @click="openProdWhats();eventAnalytics('ProdWhatsMenuH')">
              <v-list-item-icon>
                <v-icon>mdi-whatsapp</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ $t('Home.MenuHome.ProdWhats') }}</v-list-item-title>
            </v-list-item>

          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </template>

    <v-btn
      color="transparent"
      elevation="0"
      class="p-0 mr-1 btn-menu"
      small
      @click="eventAnalytics('ClkHome')"
      style="outline: none;"
    >
      <a
        href="/"
        class="font-weight-light text-capitalize grey--text text--darken-1"
        style="text-decoration: none;"
      >{{ $t("Home.MenuHome.home") }}</a>
    </v-btn>

    <v-btn
      color="transparent"
      elevation="0"
      class="p-0 mr-1 btn-menu"
      small
      @click="eventAnalytics('ProdMenuH')"
      style="outline: none;"
    >
      <a
        href="/products/nownow"
        class="font-weight-light text-capitalize grey--text text--darken-1"
        style="text-decoration: none;"
      >{{ $t("Home.MenuHome.product") }}</a>
    </v-btn>

    <v-btn
      color="transparent"
      elevation="0"
      class="p-0 mr-1 btn-menu"
      small
      @click="eventAnalytics('ProdWhatsMenuH')"
      style="outline: none;"
    >
      <a
        href="/products/whatsapplink"
        class="font-weight-light text-capitalize grey--text text--darken-1"
        style="text-decoration: none;"
      >{{ $t("Home.MenuHome.ProdWhats") }}</a>
    </v-btn>

    <v-btn
      color="transparent"
      elevation="0"
      class="p-0 ml-0 mr-1 btn-menu"
      small
      style="outline: none;"
    >
      <a
        href="/login"
        class="font-weight-light text-capitalize grey--text text--darken-1"
        style="text-decoration: none;"
      >{{ $t("Home.MenuHome.login") }}</a>
    </v-btn>

    <v-btn
      color="purple darken-4"
      elevation="0"
      class="px-1 btn-menu"
      small
      @click="eventAnalytics('SgnMenuH')"
      style="outline: none;"
    >
      <a
        href="/signup"
        class="caption font-weight-light text-capitalize white--text"
        v-html="$t('Home.MenuHome.signUp')"
        style="text-decoration: none;"
      ></a>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { analytics } from "@/config/firebaseConfig";
export default {
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    eventAnalytics(nameEvent) {
      console.log(`Btn_${nameEvent}`);
      analytics.logEvent(`Btn_${nameEvent}`);
    },
    openHome() {
      window.location.href = `${process.env.VUE_APP_USER_URL}`
    },
    openProduct() {
      window.location.href = `${process.env.VUE_APP_USER_URL}products/nownow`;
    },
    openProdWhats() {
      window.location.href = `${process.env.VUE_APP_USER_URL}products/whatsapplink`;
    },
    openLogin() {
      window.location.href = `${process.env.VUE_APP_USER_URL}login`;
    },
    openSignUp() {
      window.location.href = `${process.env.VUE_APP_USER_URL}signup`;
    },
  },
};
</script>

<style>
.v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 8px !important;
}

.toggle-menu {
  display: none !important;
}

.btn-menu {
  display: inline !important;
}
@media (max-width: 600px) {
  .toggle-menu {
    display: inline !important;
  }
  .btn-menu {
    display: none !important;
  }
}
</style>